// extracted by mini-css-extract-plugin
module.exports = {"entry":"Entry_entry__Kk7su","keyword":"Entry_keyword___WDeJ"};